import { useEffect, useRef } from "react";
import { Button, Card } from "react-bootstrap";
import styled from "styled-components"

const Wrap = styled.div`
    .form-label {
        word-break: keep-all;
        white-space: nowrap;
    }

    .card {
        background-color: #f8fafd;
    }
    
    .card-body {
        padding: 25px 25px;
        border: 0;
        gap: 20px;
        
        &.flex-row {
            align-items: center;
        }
    }

    .form-wrap {
        flex: 1 1;
        width: 100%;
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0 8px;
    flex-shrink: 0;

    button {
        flex: 1 1;
        min-width: 100px;
        max-width: 100px;
    }
`;
export default function TableFilterBox({children, isFlex=false, handleClickReset= () => {}, handleClickSubmit= () => {}, ...props}) {
    const wrapRef = useRef();
    useEffect(() => {
        let keyupEvent;
        if (wrapRef.current.querySelectorAll("input").length > 0) {
            wrapRef.current.querySelectorAll("input").forEach(el => {
                el.addEventListener("focus", () => {
                    keyupEvent = (e) => {
                        if (e.keyCode == 13) {
                            handleClickSubmit();
                        }
                    }
                    
                    document.addEventListener("keyup",keyupEvent);
                })

                el.addEventListener("blur", () => {
                    document.removeEventListener("keyup", keyupEvent);
                })
            })
        }
        
        return () => {
            document.removeEventListener("keyup", keyupEvent);
        }
    },[]); 
    return (
        <Wrap {...props} ref={wrapRef}>
            <Card>
                <Card.Body className={"d-flex" + (isFlex ? " flex-row" : " flex-column")}>
                    <div className="form-wrap">
                        {children}
                    </div>

                    <ButtonContainer>
                        <Button variant="soft-secondary"
                        onClick={() => {
                            handleClickReset();
                        }}>초기화</Button>
                        <Button variant="primary" onClick={() => {
                            handleClickSubmit();
                        }}>검색</Button>
                    </ButtonContainer>
                </Card.Body>
            </Card>
        </Wrap>
    )
}